/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_Meta_TitleInputs */

const en_gc_editor_meta_title = /** @type {(inputs: Gc_Editor_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft Online Editor | ArtCraft Spreadsheet Workspace`)
};

const zh_gc_editor_meta_title = /** @type {(inputs: Gc_Editor_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 在线编辑器 | ArtCraft 电子表格工作区`)
};

/**
* | output |
* | --- |
* | "GridCraft Online Editor \| ArtCraft Spreadsheet Workspace" |
*
* @param {Gc_Editor_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_meta_title = /** @type {((inputs?: Gc_Editor_Meta_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_Meta_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_meta_title(inputs)
	return zh_gc_editor_meta_title(inputs)
});
export { gc_editor_meta_title as "gc.editor.meta_title" }